import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { AuthService } from 'src/app/shared-modules/services/auth.service';
import { SideNavService } from '../side-nav.service';
import { Router } from '@angular/router';
@Component({
  selector: 'fyt-default-setting',
  templateUrl: './default-setting.component.html'
})
export class DefaultSettingComponent implements OnInit, OnChanges {

  @Input() InputObj;
  @Output() onActon = new EventEmitter<any>()
  defaultObj: any = {};
  brand: any;
  branches: any;
  successMessage: any;
  branchDetails: any;
  centreName: any;

  constructor(
    private authService: AuthService,
    private sideNavService: SideNavService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getCentreBrand();
  }

  ngOnChanges() { }

  closeDialog(flag) {
    this.onActon.emit({ flag: flag, page: 'defaultSettings' })
  }

  getCentreBrand() {
    let postObj = {};
    this.sideNavService.getCentreBrandData(postObj).subscribe(res => {
      if (res.statusCode === "001") {
        this.brand = res.data;
      }
    });
  }

  getBranches(data) {
    this.branches = data.branches;
  }

  setDefaultBranch() {
    const sendObj = {
      defaultCentreName: this.defaultObj.brandData.name,
      defaultCentreID: this.defaultObj.brandData.centreId,
      defaultBranchName: this.defaultObj.centreData.branchName,
      defaultBranchId: this.defaultObj.centreData.branchId
    };

    this.sideNavService.updateDefaultBranch(sendObj).subscribe(res => {
      if (res.statusCode === "001") {
        this.successMessage = res.Message;

        this.authService.storeUserData(res.jwt, res.adminData);

        // ✅ close modal after 1 seconds
        setTimeout(() => {
          this.closeDialog('cancel');
        }, 1000);

        // ✅ update local branchDetails properly
        this.branchDetails = {
          ...this.branchDetails,
          defaultBranchId: sendObj.defaultBranchId,
          defaultBranchName: sendObj.defaultBranchName
        };

        this.centreName = sendObj.defaultBranchName;

        if (this.router.url.includes('/settingFlag')) {
          this.router.navigate([
            `/gym/branches/branch/${this.branchDetails.defaultBranchId}/settingFlag`
          ]);
        } else {
          location.reload();
        }
      }
    });
  }

}
